import { defineComponent as h, useSlots as w, computed as r, openBlock as i, createElementBlock as o, normalizeClass as k, createElementVNode as l, createCommentVNode as s, renderSlot as d } from "vue";
import { c as C } from "./cn-Bje3WtSp.js";
const B = ["type", "disabled", "aria-disabled", "aria-busy", "title"], z = {
  key: 0,
  class: "inline-flex items-center",
  "aria-hidden": "true"
}, S = {
  key: 2,
  class: "inline-flex items-center"
}, $ = {
  key: 4,
  class: "sr-only"
}, N = /* @__PURE__ */ h({
  __name: "Button",
  props: {
    variant: { default: "primary" },
    size: { default: "md" },
    type: { default: "button" },
    disabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    disabledReason: { default: void 0 },
    block: { type: Boolean, default: !1 },
    class: { default: void 0 }
  },
  emits: ["click"],
  setup(t, { expose: u, emit: b }) {
    const e = t, g = b, f = w(), v = {
      // Primary text colour resolves to `--color-text-inverse` so it stays
      // legible against whatever `--color-brand-primary` is (violet in the light
      // theme produces white-on-violet; gold in the dark theme produces
      // near-black-on-gold). Using `text-white` here would crash contrast on a
      // gold surface.
      primary: "bg-brand text-[color:var(--color-text-inverse)] hover:bg-brand-primary-hover active:bg-brand-primary-hover disabled:bg-brand/50",
      secondary: "bg-surface-default text-text-primary font-medium border border-border-strong hover:bg-surface-sunken disabled:bg-surface-default disabled:text-text-tertiary",
      ghost: "bg-transparent text-text-primary font-medium hover:bg-surface-sunken disabled:text-text-tertiary",
      destructive: "bg-danger text-white hover:bg-danger/90 disabled:bg-danger/50",
      // Alias of destructive — same visual; some call sites prefer the noun.
      danger: "bg-danger text-white hover:bg-danger/90 disabled:bg-danger/50",
      // Amber confirm — used for reversible-but-significant actions
      // (e.g. "Deactivate biometric") where `destructive` is too strong.
      warning: "bg-warning text-white hover:bg-warning/90 disabled:bg-warning/50",
      // Green confirm — affirmative actions that need a distinct positive
      // accent (e.g. "Activate biometric").
      success: "bg-success text-white hover:bg-success/90 disabled:bg-success/50"
    }, m = {
      // 32px — keyboard-dense desktop contexts (table row actions).
      sm: "h-8 px-3 text-xs gap-1.5 rounded-lg",
      // 40px — canonical desktop default. Still comfortable for mouse/trackpad;
      // touch-critical surfaces (POS, Parent Web) must use `lg` which meets the
      // 44 × 44 WCAG 2.5.5 target.
      md: "h-10 px-4 text-sm gap-2 rounded-lg",
      // 48px — touch-primary surfaces.
      lg: "h-12 px-5 text-base gap-2 rounded-lg"
    }, p = r(
      () => C(
        "inline-flex items-center justify-center font-semibold whitespace-nowrap select-none",
        "transition-[background-color,color,box-shadow,transform] duration-150",
        "active:translate-y-px",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 focus-visible:ring-offset-[color:var(--color-surface-canvas)]",
        "disabled:cursor-not-allowed disabled:active:translate-y-0",
        v[e.variant],
        m[e.size],
        e.block && "w-full",
        e.loading && "relative cursor-wait",
        e.class
      )
    ), n = r(() => e.disabled || e.loading), y = r(() => e.disabled ? e.disabledReason : void 0);
    function x(a) {
      n.value || g("click", a);
    }
    return u({ hasDefaultSlot: () => !!f.default }), (a, c) => (i(), o("button", {
      "data-kori-button": "",
      type: t.type,
      class: k(p.value),
      disabled: n.value,
      "aria-disabled": n.value || void 0,
      "aria-busy": t.loading || void 0,
      title: y.value,
      onClick: x
    }, [
      t.loading ? (i(), o("span", z, [...c[0] || (c[0] = [
        l("svg", {
          class: "h-4 w-4 animate-spin",
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          l("circle", {
            class: "opacity-25",
            cx: "12",
            cy: "12",
            r: "10",
            stroke: "currentColor",
            "stroke-width": "4"
          }),
          l("path", {
            class: "opacity-75",
            fill: "currentColor",
            d: "M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
          })
        ], -1)
      ])])) : s("", !0),
      t.loading ? s("", !0) : d(a.$slots, "leading", { key: 1 }),
      t.loading ? s("", !0) : (i(), o("span", S, [
        d(a.$slots, "default")
      ])),
      t.loading ? s("", !0) : d(a.$slots, "trailing", { key: 3 }),
      t.loading ? (i(), o("span", $, "Loading")) : s("", !0)
    ], 10, B));
  }
});
export {
  N as _
};
//# sourceMappingURL=Button.vue_vue_type_script_setup_true_lang-CYEyON9h.js.map
